import React, { Component } from 'react';
import queryString from 'query-string';

export class PaymentResponse extends Component {
    displayName = PaymentResponse.name
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

        //var url = this.props.location.search;
        //var params = queryString.parse(url);
        
        
        console.log(window);

        var d = window.location.hash;

        if (d.indexOf('#', 0) == 0) {
            d = d.substr(1, d.length - 1);
        }
        console.log(d);

        var doc = window.parent.parent.document;
        var hf = doc.getElementById('hdncardpayments');
        var btn = doc.getElementById('hdnBtn');
        if (hf) {
            hf.value = d;
            btn.click();
            doc.forms[0].submit();
        }
    }
    render() {
        return (
            <div className="col-12">
                <div className="row">
                    
                </div >
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Shopping Cart/PaymentResponse.jsx